import * as Yup from 'yup'

export const UpdateMerchantIdentificationStatusesSchemas = Yup.object().shape({
  ident: Yup.string(),
  identTypeId: Yup.number(),
  identStatusId: Yup.number(),
  identId: Yup.number(),
})
